import { engineComponent, Logger } from "neo-common";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Symbol } from "./Symbol";
import { AnimationStyle } from "../Components/Elements/Styles/AnimationStyle";
import { StyleManager } from "../Components/Managers/StyleManager";
import { Configuration } from "../Components/Configuration";
import { ComponentTypes } from "../Components/ComponentTypes";
import { StageController } from "../Components/StageController";

/**
 * The symbols class is holder for game symbols. Class holds also textures for rotation.
 * @class Symbols
 * @extends ContainerElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Symbols extends ContainerElement {
    // instances for cloning in game
    public symbols: Array<Symbol>;
    // symbols bitmap data for reel rotation
    public symbolsData: Array<Object>;

    constructor() {
        super();

        this.symbols = [];
        this.symbolsData = [];
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    createByNode(node: Element): void {
        super.createByNode(node);

        let configs: Array<string>;

        if (node.hasAttribute(SymbolsAttributes.CONFIGS)) {
            configs = node.getAttribute(SymbolsAttributes.CONFIGS).split(";");
        }

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Symbol) {
                    if (configs != null) {
                        for (let i: number = 0; i < configs.length; i++) {
                            this.childs[key].configurate(Configuration.Configurations[configs[i]]);
                        }
                    }
                    this.symbols.push(this.childs[key]);
                }
            }
        }

        if (this.symbols != null) {
            // this.createSymbolsData();
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.removeChildren();

        this.visible = false;

        this.createObjectPool();
    }

    /**
     * Create symbols bitmap data for reel rotation.
     * Store normal case of symbol for static symbols and blur case for rotation.
     * @method createSymbolsData
     * @retutn void
     */
    createSymbolsData(): void {
        if (DEBUG) {
            this.log("createSymbolsData");
        }

        for (let i: number = 1; i <= this.symbols.length; i++) {
            if (this.symbols[i - 1].hasElements) {
                let caseElement: Element;
                // let rotationBitmap: PIXI.Texture = null;
                // let blurBitmap: PIXI.Texture = null;

                // create data from rotation but if symbol doesnt have rotation try blur or normal
                if (this.symbols[i - 1].hasCase(Symbol.CaseRotation)) {
                    caseElement = this.symbols[i - 1].getCase(Symbol.CaseRotation);
                } else {
                    if (this.symbols[i - 1].hasCase(Symbol.CaseBlur)) {
                        caseElement = this.symbols[i - 1].getCase(Symbol.CaseBlur);
                    } else {
                        if (this.symbols[i - 1].hasCase(Symbol.CaseNormal)) {
                            caseElement = this.symbols[i - 1].getCase(Symbol.CaseNormal);
                        } else {
                            if (DEBUG) {
                                this.log("ERROR Symbol has no CaseRotation, CaseBlur nor CaseNormal. Symbol ID: " + i);
                            }
                        }
                    }
                }

                // rotationBitmap = this._getBitmapByCaseElement(caseElement);
                // if (rotationBitmap == null) {
                //     if (DEBUG) {
                //         this.log('ERROR no style, animation or image of symbol with ID: ' + i + ' case: ' + Symbol.CaseRotation);
                //     }
                // }

                if (this.symbols[i - 1].hasCase(Symbol.CaseBlur)) {
                    caseElement = this.symbols[i - 1].getCase(Symbol.CaseBlur);
                }

                // blurBitmap = this._getBitmapByCaseElement(caseElement);
                // if (blurBitmap == null) {
                //     if (DEBUG) {
                //         this.log('ERROR no style, animation or image of symbol with ID: ' + i + ' case: ' + Symbol.CaseBlur);
                //     }
                // }

                // let object: Object = {};
                //
                // if (rotationBitmap != null) {
                //     object[Symbol.CaseRotation] = rotationBitmap;
                // }
                //
                // if (blurBitmap != null) {
                //     object[Symbol.CaseBlur] = blurBitmap;
                // } else {
                //     if (rotationBitmap != null) {
                //         object[Symbol.CaseBlur] = rotationBitmap;
                //     }
                // }
                //
                // if (object != null) {
                //     object['zIndex'] = this.symbols[i - 1].zIndex;
                //     this.symbolsData.push(object);
                // }
            }
        }
    }

    /**
     * Gef first child of case element.
     *
     * @param caseElement
     * @returns {PIXI.Texture}
     * @private
     */
    private _getBitmapByCaseElement(caseElement: Element): PIXI.Texture {
        if (caseElement != null) {
            if (caseElement.firstElementChild.hasAttribute("Style")) {
                if (DEBUG) {
                    /* todo Add check for parentNode existence */
                    this.log(
                        "WARNING Please use Animation attribute! Node: " +
                            caseElement.parentNode.parentNode.nodeName +
                            ", Case: " +
                            caseElement.getAttribute("Case"),
                    );
                }

                if (<AnimationStyle>StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")] != null) {
                    if (
                        <AnimationStyle>(
                            StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")].animation
                        ) != null
                    ) {
                        return StageController.getTextureByResourceId(
                            <AnimationStyle>(
                                StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")].animation
                            ) + "0000",
                        );
                    }
                }
            } else if (caseElement.firstElementChild.hasAttribute("FromFrame")) {
                if (caseElement.firstElementChild.getAttribute("FromFrame") != null) {
                    return StageController.getTextureByResourceId(
                        caseElement.firstElementChild.getAttribute("FromFrame"),
                    );
                }
            } else if (caseElement.firstElementChild.hasAttribute("Image")) {
                return StageController.getTextureByResourceId(caseElement.firstElementChild.getAttribute("Image"));
            } else {
                return null;
            }
        }
        return null;
    }

    //******************************************************************************************************************
    //  OBJECT POOL
    //******************************************************************************************************************

    protected objectPool: Array<Array<Symbol>>;

    protected objectContainer: ContainerElement;

    /**
     * Create object pool of symbols length.
     */
    protected createObjectPool(): void {
        this.objectPool = [];

        for (let i = 0; i < this.symbols.length; i++) {
            this.objectPool.push([]);
        }

        this.objectContainer = new ContainerElement();
        this.objectContainer.name = "ObjectContainer";
    }

    /**
     * Get symbol from pool or clone new and go to case..
     * @param {number} id
     * @param {string} caseType
     * @returns {Symbol}
     */
    public getSymbol(id: number, caseType: string): Symbol {
        let symbol: Symbol;

        if (this.objectPool[id].length === 0) {
            symbol = this.symbols[id].clone();
            symbol.name = "Symbol" + id;
            symbol.id = id;
        } else {
            symbol = this.objectPool[id].pop();
        }

        symbol.visible = true;
        symbol.goToCase(caseType);

        return symbol;
    }

    /**
     * Return symbol into pool.
     * @param {Symbol} symbol
     */
    public returnSymbol(symbol: Symbol): void {
        symbol.visible = false;
        symbol.goToCase(Symbol.CaseEmpty);

        this.objectContainer.addChild(symbol);

        this.objectPool[symbol.id].push(symbol);
    }
}

const SymbolsAttributes = {
    /**
     * Name of config for symbol instance.
     * @property Configs
     * @type string
     * @default null
     */
    CONFIGS: "Configs",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Symbols.ts
 **/